
import { toast } from 'react-toastify';
import { TOSTAR_POSITION, INVALID_RESPNSE_OBJECT } from 'src/constants/NotificationMessageConstant';
import { history } from 'src/store/config';


export const ShowSuccessOrError = (message: any, res: any) => {
    if (res.data && res.data.success) {
        if (res.data.success && message) {
            toast.success(message, { position: TOSTAR_POSITION });
        }
        else if (!res.data.success) {
            toast.error(res.data.error.messages[0], { position: TOSTAR_POSITION });
        }
    }
    else if (!res.data.success && res.data.error && res.data.error.messages[0]) {
        toast.error(res.data.error.messages[0], { position: TOSTAR_POSITION });
    } else {
        toast.error(INVALID_RESPNSE_OBJECT, { position: TOSTAR_POSITION });
    }
}

export const ShowCustomError = (message: any) => {
    toast.error(message, { position: TOSTAR_POSITION });
}

export const ShowCustomSuccess = (message: any) => {
    toast.success(message, { position: TOSTAR_POSITION });
}

export const ShowException = (error: any) => {
    if (error.response && error.response.status) {
        if (error.response.status !== 200) {
            if (error.response.status === 403 || error.response.status === 401) {
                history.push('/unauthorized');
            }
            // else {
            //     history.push('/error');
            // }
            if (error.response.data && error.response.data.error && error.response.data.error.messages[0].length > 0) {
                toast.error(error.response.data.error.messages[0], { position: TOSTAR_POSITION });
            }
        }
    } else {
        toast.error(INVALID_RESPNSE_OBJECT, { position: TOSTAR_POSITION });

    }
}


export const ShowError = (message: any) => {
    toast.error(message, { position: TOSTAR_POSITION });
}


// WEBPACK FOOTER //
// ./src/effects/utils/tostar.tsx